export const printPage = (title?: string) => {
  if (title) {
    document.title = title;
  }

  window.print();

  document.title = 'sionum';
};
